'use client';

import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import type { CustomLabelComponents } from '@/app/common/filters/core/filtersTypes.ts';
import type { Localization } from '@/app/components/search/common/Localization.ts';
import type { ColumnOverride } from '@/app/common/filters/surfaces/columns.ts';
import type { Brand } from '@/domainLogic/index.ts';

export type FiltersUiData = {
  localization: Localization;
  isMobile: boolean;
  customLabelComponents?: CustomLabelComponents;
  columnOverrides?: ColumnOverride[];
  filtersWithRowLayout?: string[];
  brand?: Brand;
  useEvoFilters?: boolean;
  totalResults?: number;
};

export const FiltersUiContext = createContext<FiltersUiData>({} as FiltersUiData);

export default function FiltersUiProvider({
  filtersUiData,
  children,
}: {
  filtersUiData: FiltersUiData;
  children: ReactNode;
}) {
  return <FiltersUiContext.Provider value={filtersUiData}>{children}</FiltersUiContext.Provider>;
}

export const useFiltersUiData = () => {
  const context = useContext(FiltersUiContext);

  if (context === undefined) {
    throw new Error('useFiltersUiData must be within a FiltersUiProvider');
  }
  return context;
};
